import React from "react";

import DirectorImg from "../Component/Director.png"; // ✅ सही Path देख लेना
import "./DirectorMessage.css";

const DirectorMessage = () => {
  return (
    <>


      <div className="director-section container py-5">
        <div className="row align-items-center">
          
          <div className="col-md-4 text-center">
            <img 
              src={DirectorImg} 
              alt="Director" 
              className="img-fluid rounded shadow"
              style={{ width: "100%", maxWidth: "300px" }}
            />
            <h4 className="mt-3 fw-bold">Shri Abhay Singh</h4>
            <p className="text-muted">Director, CPIT Ghazipur</p>
          </div>

          <div className="col-md-8">
            <h2 className="fw-bold mb-3">Director's Message</h2>
            <p style={{ textAlign: "justify", lineHeight: "1.8" }}>
              It is my pleasure and privilege to take you around our Institute - CAREER POINT OF INFORMATION TECHNOLOGY (CPIT), at Ghazipur (U.P.). The Institute is located in the heart of Ghazipur. The Institute has spacious building of 2500 sq. ft. with outstanding infrastructure amidst excellent surroundings. We at CPIT have a track record of imparting quality education with an emphasis to prepare our management students as per requirements of industry for the challenges of tomorrow.
              <br /><br />
              We offer challenging curriculum which provides opportunities of academic achievements and at the same time also focuses on personal development of students. CPIT strives to create a learning culture with emphasis on creative and analytical mind frame.
              <br /><br />
              We invite & welcome you to empower yourself by joining the winning team of CPIT’s students and alumni, famous for its excellence.
            </p>
          </div>

        </div>
      </div>

    </>
  );
};

export default DirectorMessage;
